module.exports = __webpack_public_path__ + "img/shoppingBag.83388620.svg";